import {Grid} from '@jobseeker/lotus/foundations';
import CharactersList from './CharactersList';
import {Typography} from '@mui/material';
import {Sitemap} from '../types';
import {Link} from '@jobseeker/lotus/elements';
import {CATEGORY_ARRAY} from '@constants';
import {capitalizeFirstLetter} from '@utils';

const JobCategories = ({categories}: Sitemap) => {
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  return (
    <>
      <Typography component="h2" mb={1}>
        Job Categories
      </Typography>
      <CharactersList />
      {isAppIimjobs && (
        <Grid container spacing={2}>
          {categories.map(({label, dataId}) => (
            <Grid item key={label} xs={4}>
              <Link href={`sitemap/c/${dataId}`} target="_blank">
                {label}
              </Link>
            </Grid>
          ))}
        </Grid>
      )}
      {!isAppIimjobs && (
        <>
          <Grid container spacing={2}>
            {CATEGORY_ARRAY.map(
              ({dataId, label}: {dataId: string; label: string}) => (
                <Grid item key={dataId} xs={4}>
                  <Link href={`/sitemap/c/${dataId}`} target="_blank">
                    {capitalizeFirstLetter(label)}
                  </Link>
                </Grid>
              )
            )}
          </Grid>
          <Typography component="h2" mb={1} mt={2}>
            Available Jobs based on Category
          </Typography>
          <Grid container spacing={2}>
            {CATEGORY_ARRAY.map(
              ({dataId, label}: {dataId: string; label: string}) => (
                <Grid item key={dataId} xs={4}>
                  <Link href={`/sitemap/category/${dataId}`} target="_blank">
                    {capitalizeFirstLetter(label)} Jobs
                  </Link>
                </Grid>
              )
            )}
          </Grid>
        </>
      )}
    </>
  );
};

export default JobCategories;
